import { jackPotLabel } from "./jackPotLabel";
import { CommonData } from "../../datastructures/gamestate/gameData";
// import { TopbarPortraitMode } from "../../gameLib/gameUIBar/portraitTopBar";
// import { GameData } from "../../gamestate/gameData";

export class JackpotCounterBuilder {
  private rootParent: PIXI.Container = new PIXI.Container();
  private parent: PIXI.Container;
  // private countersContainer: PIXI.Container=new  PIXI.Container;
  private countersPar: PIXI.Container;
  private blackBarPar: PIXI.Container;
  private mega: jackPotLabel;
  private midi: jackPotLabel;
  private mini: jackPotLabel;
  private activeGameData: CommonData; //used for currency and oth
  private jackpotsList: Array<jackPotLabel>;
  // private bgPortrait:PIXI.Sprite;
  // private bgPortraitMask:PIXI.Graphics;
  // private bgImgWidth:number;
  // private topBarPortrait:TopbarPortraitMode;
  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    parent.addChild(this.rootParent);
    this.parent = new PIXI.Container();
    this.rootParent.addChild(this.parent);

    this.countersPar = new PIXI.Container();
    this.parent.addChild(this.countersPar);
    this.blackBarPar = new PIXI.Container();
    this.parent.addChild(this.blackBarPar);

    this.activeGameData = activeGameData;
    this.mega = new jackPotLabel(
      this.countersPar,
      this.activeGameData.gameTextGeneral.MEGA,
      activeGameData,
      10
    );
    this.midi = new jackPotLabel(
      this.countersPar,
      this.activeGameData.gameTextGeneral.MIDI,
      activeGameData,
      10
    );
    this.mini = new jackPotLabel(
      this.countersPar,
      this.activeGameData.gameTextGeneral.MINI,
      activeGameData,
      10
    );
    this.jackpotsList = [this.mini, this.midi, this.mega];
    this.setJackpotIsEnabledForTheGame(false);

    this.setDefaultPosition();
  }

  public setAvailable = (bool: boolean): void => {
    this.mega.setAvailable(bool);
    this.midi.setAvailable(bool);
    this.mini.setAvailable(bool);
  };
  public setAvailableIndex = (
    jackpotLevelIndex: number,
    bool: boolean
  ): void => {
    switch (jackpotLevelIndex) {
      case 1:
        this.mini.setAvailable(bool);
        break;
      case 2:
        this.midi.setAvailable(bool);
        break;
      case 3:
        this.mega.setAvailable(bool);
        break;
      default:
        // Handle invalid jackpotLevelIndex
        console.error("Unvalid JackpotLevel was requested");
        break;
    }
  };

  public setPortraitPosition = (): void => {
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let screenRatio = window.innerHeight / window.innerWidth;

    if (
      this.activeGameData.playOnPortrait &&
      this.activeGameData.isMobile &&
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      //---
      this.setCounterVerticalMode(true);
      //-----------
      let newScaleSmall = 1.5; //1.54;
      let newScaleBig = 1.5; //3.085;
      this.mini.setScale(newScaleSmall);
      this.midi.setScale(newScaleSmall);
      this.mega.setScale(newScaleBig);
      let w_small = this.mini.getBG().width * newScaleSmall;

      // old
      // this.mega.setPosition(w_small-(this.mini.getBG().width/2)*newScaleBig,this.mini.getBG().height*newScaleSmall+15)//this.mega.getBG().height*newScaleBig);
      // this.mini.setPosition(0,0);
      // this.midi.setPosition(w_small+35,0);

      //new
      // this.mega.setPosition(w_small - (this.mini.getBG().width / 2) * newScaleBig, this.mini.getBG().height * newScaleSmall + 15)//this.mega.getBG().height*newScaleBig);
      let posY = -this.mini.getBG().height * newScaleSmall * 2 + 20; //this.mini.getBG().height * newScaleSmall + 15;  //--previous one
      this.mini.setPosition(18, posY);
      this.midi.setPosition(w_small + 35 + 8, posY);
      this.mega.setPosition(this.activeGameData.size[0] / 2, posY); //this.mega.getBG().height*newScaleBig);

      this.countersPar.y = -170; //-this.activeGameData.portraitPlayOffsetTop/1.4;
      // this.bgPortrait.width=50;
      // let newBgScale=this.activeGameData.size[0]/ this.bgImgWidth
      // this.bgPortrait.scale.set(newBgScale);
      // this.bgPortrait.y=-this.activeGameData.portraitPlayOffsetTop;
      // this.bgPortraitMask.y=-this.activeGameData.portraitPlayOffsetTop;
      // this.bgPortraitMask.alpha=.5;

      this.blackBarPar.y = -this.activeGameData.portraitPlayOffsetTop / 1.35;

      this.parent.x = 0;

      // console.log('PORTRAIT MODE');
    } else {
      // console.log('LANDSCAPE MODE')
      this.setCounterVerticalMode(false);
      //--
      this.setDefaultPosition();
      //--
    }
  };

  private setCounterVerticalMode = (bool: boolean): void => {
    this.mega.setDisplayToVertical(bool);
    this.midi.setDisplayToVertical(bool);
    this.mini.setDisplayToVertical(bool);

    if (bool) {
      this.mega.setAlignDetailsTo("right");
      this.midi.setAlignDetailsTo("center");
      this.mini.setAlignDetailsTo("left");
    } else {
      this.mega.setAlignDetailsTo("right");
      this.midi.setAlignDetailsTo("right");
      this.mini.setAlignDetailsTo("right");
    }
  };
  private setDefaultPosition = (): void => {
    // this.bgPortrait.scale.set(0);
    this.countersPar.y = 0;
    this.countersPar.x = 0;
    this.countersPar.scale.set(1);
    this.mini.setScale(1);
    this.midi.setScale(1);
    this.mega.setScale(1);
    //--check type of game;
    // console.log("CHECK POSITION", this.activeGameData.gameType)
    if (
      this.activeGameData.gameType == this.activeGameData.gameTypesList[0] ||
      this.activeGameData.gameType == this.activeGameData.gameTypesList[2]
    ) {
      //if  reel game

      if (this.activeGameData.isMobile) {
        this.parent.scale.set(1.35);
        let offset = 250;
        this.mega.setPosition(
          this.activeGameData.size[0] - this.mega.getWidth() - offset * 2,
          0
        );
        this.midi.setPosition(
          this.activeGameData.size[0] / 2 - this.midi.getWidth() / 2 - offset,
          0
        );
        this.mini.setPosition(0, 0);
        // this.parent.scale.set(1.3);
      } else {
        this.mega.setPosition(
          this.activeGameData.size[0] / 2 + this.mega.getWidth() / 2 + 70,
          10
        );
        this.midi.setPosition(
          this.activeGameData.size[0] / 2 - this.midi.getWidth() / 2,
          10
        );
        this.mini.setPosition(
          this.activeGameData.size[0] / 2 -
            this.mini.getWidth() -
            this.mini.getWidth() / 2 -
            70,
          10
        );
      }
    }
    if (this.activeGameData.gameType == this.activeGameData.gameTypesList[1]) {
      // this.midi.setPosition(this.activeGameData.size[0] / 2 - this.midi.getWidth() / 2, 10);
      this.mini.setPosition(10, 10);

      this.mini.setWidth(370);
      this.midi.setPosition(this.mini.getWidth() + 20, 10);
      this.mega.setWidth(835);
      this.mega.setPosition(
        this.activeGameData.size[0] - this.mega.getWidth() - 10,
        10
      );
      this.mega.setLabelText("MEGA JACKPOT");
    }
  };
  public setInitialValue = (values_A: Array<number>): void => {
    this.mini.setInitialValue(values_A[0]);
    this.midi.setInitialValue(values_A[1]);
    this.mega.setInitialValue(values_A[2]);
    this.updateDetails();
  };
  public setNewValues = (values_A: Array<number>): void => {
    this.compareValuesAndShine(values_A);
    this.mini.setNewValue(values_A[0]);
    this.midi.setNewValue(values_A[1]);
    this.mega.setNewValue(values_A[2]);
    this.updateDetails();
  };

  private compareValuesAndShine = (values_A: Array<number>): void => {
    let val0 = this.mini.getCurrentValue();
    let val1 = this.midi.getCurrentValue();
    let val2 = this.mega.getCurrentValue();

    // console.log(val0,val1,val2,values_A)
    if (val0 > values_A[0]) {
      this.setShineIndex(0);
    }
    if (val1 > values_A[1]) {
      this.setShineIndex(1);
    }
    if (val2 > values_A[2]) {
      this.setShineIndex(2);
    }
  };

  public setDiceGamePlacement = (): void => {
    //a replacement for games such as dice spinners where there is dice generator in middle of game;

    // this.mini.setScale(.9,1);
    // this.midi.setScale(.9,1);

    this.midi.setPosition(this.mini.getWidth() - 20, 10);
    this.mini.setPosition(0, 10);

    this.mega.setPosition(
      this.activeGameData.size[0] - this.mega.getWidth(),
      10
    );

    // this.mega.label.text = "MEGA JACKPOT";
    // this.mega.label.x = -  this.mega.getWidth() + 150;

    this.mega.setLongLabel(this.activeGameData.gameTextGeneral.megajackpot); //  "MEGA JACKPOT")
  };
  public ServerResponseSuccess = (bool: boolean): void => {
    // change text to "..."
    this.mega.setNoJackpotDots(bool);
    this.midi.setNoJackpotDots(bool);
    this.mini.setNoJackpotDots(bool);
  };
  public setButtonMode = (bool: boolean): void => {
    if (this.countersPar.alpha > 0) {
      this.mini.setButtonMode(bool);
      this.midi.setButtonMode(bool);
      this.mega.setButtonMode(bool);
    } else {
      this.mini.setButtonMode(false);
      this.midi.setButtonMode(false);
      this.mega.setButtonMode(false);
    }
  };
  public setShineIndex = (index: number): void => {
    this.jackpotsList[index].playShineAnimation();
  };
  public setVisibility = (bool: boolean) => {
    var i = bool ? 1 : 0;
    this.countersPar.alpha = i;

    // this.parent.scale.set(i);
    this.setButtonMode(bool);
  };
  // public setVisibilityLabel=(bool:boolean)=>
  // {

  //     // this.parent.alpha=i;
  //     this.mega.setVisible(bool);
  //     this.midi.setVisible(bool);
  //     this.mini.setVisible(bool);
  // }
  public setJackpotIsEnabledForTheGame = (bool: boolean): void => {
    if (bool && this.rootParent.alpha == 0) {
      this.activeGameData.jackPotGameAvailable = true; //jackpot data isnt empty
      this.activeGameData.jackPotGameInstantiated = false; //jackpot are all Instantiated

      // Check if at least one or more jackpots are instantiated and set to true
      if (
        this.activeGameData.jackpotResponse?.some(
          (jackpot) => jackpot.jackpotInstantiated
        )
      ) {
        this.activeGameData.jackPotGameInstantiated = true;
      }

      this.rootParent.alpha = 1;
      this.rootParent.scale.set(this.rootParent.alpha);
    } else if (this.rootParent.alpha == 1 && bool == false) {
      this.activeGameData.jackPotGameAvailable = false; //jackpot data is empty
      this.activeGameData.jackPotGameInstantiated = false;
      this.rootParent.alpha = 0;
      this.rootParent.scale.set(this.rootParent.alpha);
    }
    this.activeGameData?.updateJackpotRtpInfo();
  };
  private updateDetails = (): void => {
    // let minipotData={"jackpotLevel":0,"currentValue":{"amount":0,"currency":this.activeGameData.currency},"bigWinDateTime":"2020-04-29T14:18:48Z",
    // "bigWinValue":{"amount":1758,"currency":"EUR"},"lastWinDateTime":"2020-04-29T15:08:43Z",
    // "lastWinValue":{"amount":1066,"currency":"EUR"},"lastWinWinnerDisplayName":"wardb","timesWon":4}

    // var minipotData = {type:"minipot", lastWinDate:"00/00/00", lastWinWinnerDisplayName:"/", lastWinAmount:"0",timesWon:"0",biggestWin:"0",biggestWinDate:"00/00/00"};
    // var midipotData = {type:"midipot", lastWinDate:"00/00/00", lastWinWinnerDisplayName:"/", lastWinAmount:"0",timesWon:"0",biggestWin:"0",biggestWinDate:"00/00/00"};
    // var megapotData = {type:"megapot", lastWinDate:"00/00/00", lastWinWinnerDisplayName:"/", lastWinValue:"0",timesWon:"0",biggestWin:"0",biggestWinDate:"00/00/00"};

    if (this.activeGameData.jackpotResponse != undefined) {
      // minipotData=
      let jRep = this.activeGameData.jackpotResponse;
      for (let i = 0; i < jRep.length; i++) {
        //place them in proper order
        switch (jRep[i].jackpotLevel) {
          case 1:
            var minipotData = jRep[i];
            break;
          case 2:
            var midipotData = jRep[i];
            break;

          case 3:
            var megapotData = jRep[i];
            break;

          default:
            break;
        }
      }
    }

    this.mini.updateJackpotDetails(minipotData);
    this.midi.updateJackpotDetails(midipotData);
    this.mega.updateJackpotDetails(megapotData);
  };

  public closepanel = (): void => {
    this.mini.close();
    this.midi.close();
    this.mega.close();
  };
}
